import React, { useContext, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import sounds from '@monorepo/shared/src/transformers/genericSounds';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { ActivityContext } from 'state/providers/ActivityProvider';
import GTheOrderDndRound from './components/GTheOrderDndRound';
import { SoundType } from '@monorepo/shared/src/providers/ActivityAudioProvider/types';

const formatSound = (
  name: string,
  src: string,
  vtt: string,
  category = 'instructions'
): SoundType => {
  return {
    name,
    category,
    src: { src, vtt },
  };
};

const GuessWhere: React.FC = () => {
  const [{ currentSound }, { loadAudioAssets, stopSound }] = useActivityAudio();
  const [state] = useContext(ActivityContext);

  const soundRef = useRef(currentSound);

  useEffect(() => {
    soundRef.current = currentSound;
  }, [currentSound]);

  useEffect(() => {
    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        stopSound(); // updates state
      }
    };
  }, []);
  useEffect(() => {
    const storyInstructions = state?.activity?.instructions;
    const storyElements = state?.activity?.storyElements;
    if (storyInstructions && storyElements) {
      const introSound = formatSound(
        'intro',
        storyInstructions.introduction?.src,
        storyInstructions.introduction?.vtt
      );
      const summarySound = formatSound(
        'summary',
        storyInstructions.summary?.src,
        storyInstructions.summary?.vtt
      );
      const SceneSounds: SoundType[] = storyElements.flatMap((element) => {
        const instruction = formatSound(
          element.tile.storyOrder,
          element.instructions.src,
          element.instructions.vtt
        );
        const affirmation = formatSound(
          `${element.tile.storyOrder}-affirmation`,
          element.affirmation.src,
          element.affirmation.vtt
        );
        return [instruction, affirmation];
      });
      loadAudioAssets([sounds.BOINK, introSound, summarySound, ...SceneSounds]);
    }
  }, [state?.activity]);

  return <Box>{state?.currentRound?.round && <GTheOrderDndRound />}</Box>;
};

export default GuessWhere;
